module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td colspan="7" class="pt-2">There were no votes on this date</td>\n';
}
return __p;
};
